import React, { ReactElement, useState, useEffect, useRef } from "react";

//types
import { PollRatingType } from "../../../types";

import { useTranslation } from "react-i18next";

import { getUserAnswers, updatePollResult } from "../../../apis/firebase";
import apiRequest from "../../../apis/request";
import { Method } from "axios";

const Rating = ({
  pollId,
  sessionId,
  trackId,
  showResults,
  ...props
}: PollRatingType): ReactElement => {
  const { t } = useTranslation();

  const [loading, setIsLoading] = useState(false);
  const [response, setIsResponse] = useState(false);

  const { question, canEditAnswer } = props;
  const numOfStars = props.maxValue;

  const [rating, setRating] = useState(0);
  const [ratingList, setRatingList] = useState<Array<any>>([]);

  const [userPollInfo, setUserPollInfo] = useState<any>([]);

  // Component initialize
  useEffect(() => {
    if (!pollId) return;
    (async () => {
      setUserPollInfo(await getUserAnswers(pollId, sessionId));

      updatePollResult(pollId, sessionId, (data) => {
        if (data && data?.answers) {
          const totalAns = data.totalNumOfAnswers;
          let _answers: any = Object.entries(data?.answers);
          _answers = _answers?.map((d) => ({
            rating: d[0],
            count: d[1],
            percentage: parseInt(
              parseFloat(parseInt(d[1]) / totalAns) * 100
            ).toFixed(2),
          }));
          setRatingList(_answers);
        }
      });
    })();
  }, [pollId]);

  useEffect(() => {
    if (!!userPollInfo && !!userPollInfo?.length) {
      setRating(userPollInfo[0].answer);
      setIsResponse(true);
    }
  }, [userPollInfo]);

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      const payload = {
        pollId,
        sessionId,
        trackId,
        answer: rating,
      };

      const requestType: Method = "POST";

      const { status } = await apiRequest(
        requestType,
        "polls/rating",
        [],
        payload
      );

      if (status === 200) {
        setIsLoading(false);
        setIsResponse(true);
        setUserPollInfo([...[payload]]);
      } else {
        setIsResponse(false);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleReset = () => {
    setIsLoading(false);
    setIsResponse(false);
  };

  return (
    <div className="tm__polls">
      {/* Loader - Start */}
      {loading && (
        <div className="tm__polls-loader d-flex justify-content-center align-items-center">
          <div className="spinner-border text-primary" role="status"></div>
        </div>
      )}
      {/* Loader - End */}
      <div className="tm__polls-head tm__polls-head-divider">
        <label className="fs-7 text-primary mb-0">{question}</label>
      </div>
      <div className="tm__polls-body">
        {/* Options - Start */}
        {!response && (
          <div className="d-flex flex-column flex-column align-items-center">
            <ul className="tm__rating-list d-flex list-style-none p-0 m-0">
              {[...Array(numOfStars)].map((d, i) => (
                <li key={i} onClick={() => setRating(i + 1)}>
                  <i
                    className={`bi cursor-pointer fs-3 mx-2 bi-star ${
                      i <= rating - 1 ? "active" : ""
                    }`}></i>
                </li>
              ))}
            </ul>
          </div>
        )}
        {/* Options - End */}

        {/* Response - Start */}
        {response && showResults && (
          <div className="d-flex flex-column flex-column align-items-center">
            <span className="badge bg-primary">
              {t("POLLS_RATING_SCORE")}: {rating}
              <i className="bi bi-star-fill ms-1"></i>
            </span>

            <ul className="list-style-none d-flex p-0 m-0 mt-5">
              {[...Array(numOfStars)].map((d, i) => {
                const rating = ratingList?.find(
                  (x) => parseInt(x.rating) === i + 1
                ) || {
                  rating: i + 1,
                  count: 0,
                  percentage: "0",
                };

                return (
                  <li className="mx-3">
                    <div className="form-progress form-progress-vertical">
                      <label className="fs-8">{i + 1}</label>
                      <div className="progress">
                        <div
                          className="progress-bar bg-success"
                          role="progressbar"
                          style={{ height: `${rating.percentage}%` }}></div>
                        <small>{rating.percentage}%</small>
                      </div>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        )}

        {response && !showResults && (
          <div className="tm__polls-body">
            {/* Response - Start */}
            <div className="d-flex flex-column align-items-center">
              <i className="bi bi-check-circle-fill text-primary fs-1"></i>
              <span>{t("POLLS_THANK_YOU_FOR_ANSWER")}</span>
            </div>
            {/* Response - End */}
          </div>
        )}
        {/* Response - End */}
      </div>

      <div className="tm__polls-footer tm__polls-footer-divider d-flex justify-content-center">
        {!response && (
          <button
            type="button"
            className="btn btn-primary btn-small"
            onClick={() => {
              handleSubmit();
            }}>
            {t("POLLS_SUBMIT_TEXT")}
          </button>
        )}
        {response && canEditAnswer && (
          <button
            type="button"
            className="btn btn-primary btn-small"
            onClick={() => {
              handleReset();
            }}>
            {t("POLLS_EDIT_RESPONSE")}
          </button>
        )}
      </div>
    </div>
  );
};

export default Rating;
